module.exports = __webpack_public_path__ + "img/eplogo_white_tr.9dfc5143.svg";